document.addEventListener('DOMContentLoaded', function () {
  var calcBtn = document.getElementById('ula-solar-calc-btn');
  if (!calcBtn) return;

  calcBtn.addEventListener('click', function () {
    var roadWidth = parseFloat(document.getElementById('ula-road-width').value);
    var poleHeight = parseFloat(document.getElementById('ula-pole-height').value);
    var poleSpacing = parseFloat(document.getElementById('ula-pole-spacing').value);
    var application = document.getElementById('ula-solar-application').value;
    var result = document.getElementById('ula-solar-result');

    if (!roadWidth || !poleHeight || !poleSpacing || !application) {
      result.innerHTML = '<h2>Your Result</h2><p>Please complete all fields before calculating.</p>';
      return;
    }

    var recommendedModel = '';
    var recommendedHeight = '';
    var reason = '';

    if (application === 'pathway') {
      recommendedModel = '40W Solar Street Light';
      recommendedHeight = '6–7m';
      reason = 'Suitable for pathways, walkways and smaller outdoor areas.';
    } else if (application === 'community-road') {
      recommendedModel = '60W Solar Street Light';
      recommendedHeight = '6–8m';
      reason = 'Suitable for community roads and general public outdoor lighting.';
    } else if (application === 'parking') {
      recommendedModel = poleHeight >= 9 ? '100W Solar Street Light' : '80W Solar Street Light';
      recommendedHeight = poleHeight >= 9 ? '9–11m' : '8–9m';
      reason = 'Suitable for parking areas and wider open outdoor spaces.';
    } else if (application === 'main-road') {
      recommendedModel = '100W Solar Street Light';
      recommendedHeight = '9–11m';
      reason = 'Suitable for roads requiring stronger brightness and broader coverage.';
    } else if (application === 'industrial') {
      recommendedModel = '120W Solar Street Light';
      recommendedHeight = '10–12m';
      reason = 'Suitable for industrial sites, larger roads and infrastructure projects.';
    }

    if (poleHeight <= 7 && (application === 'main-road' || application === 'industrial')) {
      recommendedModel = '80W Solar Street Light';
      recommendedHeight = '8–9m';
      reason = 'Based on your lower pole height, an 80W model may be more suitable than a higher output road model.';
    }

    if (poleHeight >= 10 && application === 'parking') {
      recommendedModel = '120W Solar Street Light';
      recommendedHeight = '10–12m';
      reason = 'For larger parking and open outdoor areas with higher poles, the 120W model is recommended.';
    }

    result.innerHTML =
      '<h2>Your Result</h2>' +
      '<div class="ula-result-box"><strong>Recommended Model</strong>' + recommendedModel + '</div>' +
      '<div class="ula-result-box"><strong>Recommended Mounting Height</strong>' + recommendedHeight + '</div>' +
      '<div class="ula-result-box"><strong>Project Inputs</strong>Road Width: ' + roadWidth.toFixed(1) + 'm<br>Pole Height: ' + poleHeight.toFixed(1) + 'm<br>Pole Spacing: ' + poleSpacing.toFixed(1) + 'm</div>' +
      '<div class="ula-result-box"><strong>Why This Model Fits</strong>' + reason + '</div>' +
      '<p class="ula-small">This is a planning estimate only. For project-specific lighting design and bulk pricing, please contact ULA1L.</p>' +
      '<p><a href="/pages/contact">Request Project Support</a></p>';
  });
});